var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div layout=\"row\" layout-align=\"end start\"><md-button ng-click=\"vm.sideTab.roles = !vm.sideTab.roles\">Close</md-button></div><div layout=\"row\"><div><h3>Add roles</h3><lookups tm-data-source=\"Lookups\" limit-to-list=\"limit-to-list\" doc-list=\"vm.docSvc.doc.roles\" list=\"roles\" doc-service-add-method=\"tmUserDocSvc.addRole\"><div style=\"border: solid black 1px; background-color: white\" class=\"itemCard\"><a href=\"\" ng-click=\"dCtrl.addItem(item)\"> <span class=\"glyphicon glyphicon-circle-arrow-left\"> </span></a><span>&nbsp; {{item}}</span></div></lookups></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/features/administration/users/tabs/addRole.jade
// module id = 178
// module chunks = 0